import { render } from "./RotateScreen.vue?vue&type=template&id=24d37c8c&scoped=true&lang=html"
import script from "./RotateScreen.vue?vue&type=script&lang=js"
export * from "./RotateScreen.vue?vue&type=script&lang=js"

import "./RotateScreen.vue?vue&type=style&index=0&id=24d37c8c&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d37c8c"]])

export default __exports__